// extracted by mini-css-extract-plugin
export default {"details":"Variable_details__WLiH8","noDetails":"Variable_noDetails__KAxMT"};